<template>
  <loading-wrapper
    :loading="loading"
    :class="{ 'section': loading }"
  >
    <div
      v-if="selectedDepartment"
      class="section no-padding-top no-padding-x"
    >
      <div class="container max-width-mobile">
        <div
          v-if="selectedDepartment.photoUrl"
          class="department-banner"
          :style="{ 'background-image': `url(${selectedDepartment.photoUrl})` }"
        />
        <h2 class="title title--2 center spacing-top">{{ selectedDepartment.name }}</h2>

        <hr>

        <mobile-tipping-form
          :department-public-id="selectedDepartment.publicId"
          :store-id="selectedDepartment.storeId"
        />
      </div>
    </div>
  </loading-wrapper>
</template>

<script>
  import mobileTippingForm from './mobile-tipping-form.vue';
  import { mapGetters } from 'vuex';

  export default {
    name: 'DepartmentTippingPage',

    components: { mobileTippingForm },

    metaInfo() {
      return {
        title: this.selectedDepartment?.name
      };
    },

    data: () => ({
      loading: true
    }),

    computed: {
      ...mapGetters('hotels', ['selectedDepartment'])
    },

    created() {
      this.onCreated();
    },

    methods: {
      async onCreated() {
        await this.$store.dispatch('hotels/fetchDepartment', this.$route.params.departmentId);
        this.loading = false;
      }
    }
  };
</script>
